// src/lib/siteSettings.js
// Small settings the team can flip from the admin panel without a code change.
// Currently just the live stream banner shown on the Events page.

import { doc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const STREAM_DOC = doc(db, "siteSettings", "stream");

export const DEFAULT_STREAM = {
  enabled: false,
  channel: "primevaloresports",
  title: "Live Now",
  subtitle: "",
  showChat: true,
};

/** Live subscription to the stream settings. Falls back to defaults. */
export function subscribeToStreamSettings(callback, onError) {
  return onSnapshot(
    STREAM_DOC,
    (snap) => callback(snap.exists() ? { ...DEFAULT_STREAM, ...snap.data() } : DEFAULT_STREAM),
    (err) => {
      console.warn("Stream settings unavailable:", err);
      if (onError) onError(err);
      else callback(DEFAULT_STREAM);
    }
  );
}

export async function updateStreamSettings(values) {
  await setDoc(
    STREAM_DOC,
    { ...values, updatedAt: serverTimestamp() },
    { merge: true }
  );
}

// ─── Site sections ────────────────────────────────────────────────────────────
// Whole sections of the site the team can show or hide, e.g. the Graduates page.

export const SECTIONS_DOC = doc(db, "siteSettings", "sections");

export const DEFAULT_SECTIONS = {
  // Hidden until the team is ready to unveil it. Flipped from the admin panel.
  graduatesEnabled: false,
};

/** Live subscription to the section toggles. Falls back to defaults. */
export function subscribeToSectionSettings(callback, onError) {
  return onSnapshot(
    SECTIONS_DOC,
    (snap) =>
      callback(snap.exists() ? { ...DEFAULT_SECTIONS, ...snap.data() } : DEFAULT_SECTIONS),
    (err) => {
      console.warn("Section settings unavailable:", err);
      if (onError) onError(err);
      else callback(DEFAULT_SECTIONS);
    }
  );
}

export async function updateSectionSettings(values) {
  await setDoc(
    SECTIONS_DOC,
    { ...values, updatedAt: serverTimestamp() },
    { merge: true }
  );
}
